<template>
  <!-- eslint-disable -->
  <div>
    <transition name="slide">
      <div v-if="window.width >= 1200 || sideMenu" class="medical-sidebar-container">
        <!-- Logo Section -->
        <div class="sidebar-header">
          <div class="logo-container">
            <img
              :src="'https://assets-prestador-clinicgo.s3.sa-east-1.amazonaws.com/' + prestador.id + '/images/logo.png'"
              style="max-height:60px; max-width: 200px; z-index:100003; top:50%; position: absolute; transform: translateY(-50%); left:20px"
              alt="Imagen" />
          </div>
          <div class="header-decoration"></div>
        </div>

        <!-- Navigation Content -->
        <div class="sidebar-content">
          <nav class="medical-navigation">
            <div class="nav-inner">
              <ul class="nav-menu">
                <!-- Menu Items -->
                <li v-for="m in filteredMenu" :key="m.nombre" v-if="hasPermissions(m)" :class="{
                  'nav-item': !m.seccion,
                  'nav-section': m.seccion,
                  'nav-item-active': $route.name == m.nombre || m.nombres_activos.includes($route.name),
                  'nav-item-expanded': m.viendo,
                  'nav-item-has-children': m.subrutas != undefined
                }">
                  <!-- Section Header -->
                  <div v-if="m.seccion" class="nav-section-header">
                    <span class="section-title">{{ m.nombre }}</span>
                    <div class="section-divider"></div>
                  </div>

                  <!-- Menu Link -->
                  <div v-else class="nav-link" :class="{
                    'nav-link-active': $route.name == m.nombre || m.nombres_activos.includes($route.name),
                    'nav-link-expandable': m.subrutas != undefined
                  }" :style="{
                    background: $route.name == m.nombre || m.nombres_activos.includes($route.name)
                      ? 'linear-gradient(135deg, ' + prestador.admin.assets.colors.primary + ', ' + prestador.admin.assets.colors.secondary + ')'
                      : '',
                  }">
                    <router-link v-if="m.to" :to="{ name: m.to }" class="nav-link-content" exact
                      active-class="nav-link-active"
                      style="display: flex; align-items: center; width: 100%; color: inherit; text-decoration: none;">
                      <div class="nav-icon-container">
                        <div class="nav-icon-bg" :style="{
                          background: $route.name == m.nombre || m.nombres_activos.includes($route.name)
                            ? 'rgba(255, 255, 255, 0.2)'
                            : 'rgba(' + hexToRgb(prestador.admin.assets.colors.primary) + ', 0.1)'
                        }">
                          <i :class="m.icono" class="nav-icon"
                            :style="{ color: prestador.admin.assets.colors.primary }"></i>
                        </div>
                      </div>
                      <span class="nav-text">{{ m.nombre }}</span>
                      <div v-if="m.subrutas" class="nav-expand-icon"
                        :style="{ transform: m.viendo ? 'rotate(180deg)' : 'rotate(0deg)' }">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M6 9l6 6 6-6"></path>
                        </svg>
                      </div>
                    </router-link>

                    <div v-else class="nav-link-content" @click="m.viendo = !m.viendo"
                      style="cursor: pointer; display: flex; align-items: center;">
                      <div class="nav-icon-container">
                        <div class="nav-icon-bg" :style="{
                          background: $route.name == m.nombre || m.nombres_activos.includes($route.name)
                            ? 'rgba(255, 255, 255, 0.2)'
                            : 'rgba(' + hexToRgb(prestador.admin.assets.colors.primary) + ', 0.1)'
                        }">
                          <i :class="m.icono" class="nav-icon"
                            :style="{ color: prestador.admin.assets.colors.primary }"></i>
                        </div>
                      </div>
                      <span class="nav-text">{{ m.nombre }}</span>
                      <div v-if="m.subrutas" class="nav-expand-icon"
                        :style="{ transform: m.viendo ? 'rotate(180deg)' : 'rotate(0deg)' }">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M6 9l6 6 6-6"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <!-- Submenu -->
                  <div v-if="m.viendo && m.subrutas" class="nav-submenu">
                    <ul class="submenu-list">
                      <li v-for="sub in m.subrutas" :key="sub.nombre"
                        v-if="hasPermissions(sub) && hasPrestadorAccess(sub)" class="submenu-item"
                        :class="{ 'submenu-item-active': isSubrutaActiva(sub) }">

                        <router-link v-if="sub.to" :to="typeof sub.to === 'string' ? { name: sub.to } : sub.to"
                          class="submenu-link" exact active-class="submenu-link-active" :style="{
                            color: isSubrutaActiva(sub) ? prestador.admin.assets.colors.primary : '',
                            background: isSubrutaActiva(sub) ? 'rgba(' + hexToRgb(prestador.admin.assets.colors.primary) + ', 0.1)' : '',
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            width: '100%'
                          }">
                          <div class="submenu-indicator">
                            <div class="submenu-dot"
                              :style="{ background: isSubrutaActiva(sub) ? prestador.admin.assets.colors.primary : '#cbd5e1' }">
                            </div>
                          </div>
                          <span class="submenu-text">{{ sub.nombre }}</span>
                        </router-link>

                        <div v-else class="submenu-link" @click="sub.viendo = !sub.viendo"
                          :class="{ 'submenu-link-active': isSubrutaActiva(sub) }" :style="{
                            color: isSubrutaActiva(sub) ? prestador.admin.assets.colors.primary : '',
                            background: isSubrutaActiva(sub) ? 'rgba(' + hexToRgb(prestador.admin.assets.colors.primary) + ', 0.1)' : '',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center'
                          }">
                          <div class="submenu-indicator">
                            <div class="submenu-dot"
                              :style="{ background: isSubrutaActiva(sub) ? prestador.admin.assets.colors.primary : '#cbd5e1' }">
                            </div>
                          </div>
                          <span class="submenu-text">{{ sub.nombre }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>

                </li>
              </ul>
            </div>
          </nav>

          <!-- Sidebar Footer -->
          <div class="sidebar-footer">
            <div class="footer-decoration">
              <div class="medical-pattern">
                <svg width="100%" height="40" viewBox="0 0 200 40" fill="none">
                  <defs>
                    <linearGradient id="medicalGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%"
                        :style="`stop-color:${prestador.admin.assets.colors.primary};stop-opacity:0.1`" />
                      <stop offset="100%"
                        :style="`stop-color:${prestador.admin.assets.colors.secondary};stop-opacity:0.1`" />
                    </linearGradient>
                  </defs>
                  <path d="M0,20 Q50,10 100,20 T200,20" stroke="url(#medicalGradient)" stroke-width="2" fill="none" />
                  <circle cx="50" cy="20" r="3" :fill="prestador.admin.assets.colors.primary" opacity="0.3" />
                  <circle cx="150" cy="20" r="3" :fill="prestador.admin.assets.colors.secondary" opacity="0.3" />
                </svg>
              </div>
            </div>
            <div class="footer-info">
              <div class="platform-badge">
                <div class="badge-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                  </svg>
                </div>
                <span>ClinicGo</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Mobile Overlay -->
    <div @click="CambiarMenuAction({})" v-if="window.width < 1200 && sideMenu" class="mobile-overlay"></div>
  </div>
</template>

<script>
import '@/assets/estilo_importado/vendor/css/rtl/core.css';
import '@/assets/estilo_importado/vendor/css/rtl/theme-default.css';
import '@/assets/estilo_importado/css/demo.css';
import '@/assets/estilo_importado/vendor/libs/node-waves/node-waves.css';
import '@/assets/estilo_importado/vendor/libs/perfect-scrollbar/perfect-scrollbar.css';
import '@/assets/estilo_importado/vendor/libs/typeahead-js/typeahead.css';
import '../assets/estilo_importado/vendor/fonts/tabler-icons.css';
import '../assets/estilo_importado/vendor/fonts/fontawesome.css';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SideNav',
  data() {
    return {
      window: { width: 0, height: 0 },
      menu_items: [
        { nombre: 'General', seccion: true, nombres_activos: [] },
        { nombre: 'Inicio', icono: 'ti ti-smart-home', to: 'Inicio', nombres_activos: [] },
        {
          nombre: 'Atenciones Agendadas',
          icono: 'ti ti-shopping-cart',
          to: 'Ordenes',
          permissions: ['permiso_general'],
          nombres_activos: ['Ordenes'],
        },
        {
          nombre: 'Profesionales',
          icono: 'ti ti-users',
          to: 'Profesionales',
          nombres_activos: ['Profesional'],
          permissions: ['gestionar_profesionales'],
        },
        {
          nombre: 'Calendario',
          icono: 'ti ti-calendar',
          to: 'CalendarioGeneral',
          nombres_activos: ['CalendarioGeneral'],
          permissions: ['permiso_general'],
        },
        {
          nombre: 'Agendar Atención En Casa',
          icono: 'ti ti-user',
          to: 'AgendarAtencionEnCasa',
          nombres_activos: ['AgendarAtencionEnCasa'],
          permissions: ['gestionar_profesionales'],
          prestadores: [16, 23],

        },
        {
          nombre: 'Agendar Atención',
          icono: 'ti ti-stethoscope',
          to: 'AgendarAtencion',
          nombres_activos: ['AgendarAtencion'],
          permissions: ['gestionar_profesionales'],
          prestadores: ['*'],
          ocultar_en: [16],

        },
        {
          nombre: 'Historial Paciente',
          icono: 'ti ti-user',
          to: 'HistorialPaciente',
          nombres_activos: ['HistorialPaciente'],
          permissions: ['gestionar_profesionales'],
        },
        { nombre: 'Gráficos y mapas', seccion: true, nombres_activos: [], permissions: ['gestionar_profesionales'] },
        {
          nombre: 'Geolocalización de profesionales',
          icono: 'ti ti-map',
          to: 'Ubicacion',
          nombres_activos: ['Ubicacion'],
          permissions: ['gestionar_profesionales'],
        },
        {
          nombre: 'Panel de indicadores',
          icono: 'ti ti-chart-pie',
          to: 'ReportesMedicos',
          nombres_activos: ['ReportesMedicos'],
          permissions: ['ver_reportes'],
          ocultar_en: [16],
        },
        {
          nombre: 'Dashboard Google Analytics',
          icono: 'ti ti-brand-google',
          to: 'GoogleAnalyticsById',
          nombres_activos: ['GoogleAnalytics'],
          permissions: ['ver_reportes'],
          prestadores: [3, 5, 9, 13, 14, 15, 18],
          ocultar_en: [1, 23, 16],
        },
        {
          nombre: 'Administrador de Cotizaciones',
          icono: 'ti ti-cash',
          to: 'Cotizador',
          nombres_activos: ['Cotizador'],
          permissions: ['ver_reportes'],
          prestadores: [13, 23],

        },
        {
          nombre: 'Dashboards Google Analytics',
          icono: 'ti ti-brand-google',
          permissions: ['ver_reportes'],
          prestadores: [1, 23],
          viendo: false,
          subrutas: [
            {
              nombre: 'UC Christus',
              to: { name: 'GoogleAnalyticsById', params: { id: 14 } },
              permissions: ['ver_reportes']
            },
            {
              nombre: 'Bionet',
              to: { name: 'GoogleAnalyticsById', params: { id: 3 } },
              permissions: ['ver_reportes']
            },
            {
              nombre: 'Laboratorio Blanco',
              to: { name: 'GoogleAnalyticsById', params: { id: 13 } },
              permissions: ['ver_reportes']
            },
            {
              nombre: 'Clínica Dávila',
              to: { name: 'GoogleAnalyticsById', params: { id: 15 } },
              permissions: ['ver_reportes']
            },
            {
              nombre: 'Integra Médica',
              to: { name: 'GoogleAnalyticsById', params: { id: 9 } },
              permissions: ['ver_reportes']
            },
            {
              nombre: 'Clínica Alemana',
              to: { name: 'GoogleAnalyticsById', params: { id: 5 } },
              permissions: ['ver_reportes']
            },
            {
              nombre: 'Sports MD',
              to: { name: 'GoogleAnalyticsById', params: { id: 18 } },
              permissions: ['ver_reportes']
            }
          ],
          nombres_activos: ['GoogleAnalyticsById']
        },
        {
          nombre: 'Configuración',
          seccion: true,
          nombres_activos: [],
          permissions: ['acceso_configuracion'],
        },
        {
          nombre: 'Prestaciones',
          icono: 'ti ti-file-description',
          to: 'MaestroExamenes',
          permissions: ['gestionar_prestaciones'],
          nombres_activos: ['MaestroExamenes'],
          ocultar_en: [16],
        },
        {
          nombre: 'Aseguradoras',
          icono: 'ti ti-file-dollar',
          to: 'Aseguradoras',
          permissions: ['gestionar_aseguradoras'],
          nombres_activos: [],
          ocultar_en: [16],
        },
        {
          nombre: 'Códigos Descuento',
          icono: 'ti ti-id',
          to: 'CodigoDescuentos',
          permissions: ['gestionar_codigos_descuento'],
          nombres_activos: ['CodigoDescuentos'],
          ocultar_en: [16],
        },
        {
          nombre: 'Otras Configuraciones',
          icono: 'ti ti-settings',
          permissions: ['otras_configuraciones'],
          viendo: false,
          subrutas: [
            { nombre: 'Costos Servicios', to: 'CostosServicios', permissions: ['costos_servicios'], ocultar_en: [16] },
            { nombre: 'Precio por comuna', to: 'ModificarPrecioExamenComuna', permissions: ['precio_por_comuna'], ocultar_en: [16] },
            { nombre: 'Duración bloque', to: 'BloqueHorario', permissions: ['otras_configuraciones'], prestadores: [16] }, 
          ],
          nombres_activos: ['CostosServicios', 'ModificarPrecioExamenComuna'],
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['admin_datos', 'isLoggedIn', 'sideMenu', 'prestador', 'prestador_id']),
    filteredMenu() {
      return this.menu_items.filter((item) => this.hasPermissions(item) && this.hasPrestadorAccess(item));
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapActions(['CambiarMenuAction']),
    isSubrutaActiva(sub) {
      if (!sub.to) return false;
      if (typeof sub.to === 'string') {
        return this.$route.name === sub.to;
      }
      if (sub.to.name !== this.$route.name) return false;

      const subParams = sub.to.params || {};
      const routeParams = this.$route.params || {};
      return Object.keys(subParams).every(
        key => subParams[key] == routeParams[key]
      );
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    hasPermissions(item) {
      if (!item.permissions) return true;
      return item.permissions.every((permiso) => this.admin_datos.permissions.includes(permiso));
    },
    hasPrestadorAccess(item) {
      const pid = Number(this.prestador?.id ?? this.prestador_id);
      const includesNum = (arr, val) => Array.isArray(arr) && arr.map(Number).includes(val);

      if (!item?.prestadores && !item?.ocultar_en) return true;

      if (item?.prestadores) {
        if (item.prestadores.includes('*')) {
          return !includesNum(item.ocultar_en, pid);
        }
        return includesNum(item.prestadores, pid);
      }

      if (item?.ocultar_en) {
        return !includesNum(item.ocultar_en, pid);
      }

      return true;
    },
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
        : '59, 130, 246';
    },
  },
};
</script>

<style scoped>
/* Base Styles - Notion-inspired with medical touches */
.medical-sidebar-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-right: 1px solid #e2e8f0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  overflow: hidden;
}

/* Sidebar Header */
.sidebar-header {
  position: relative;
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.sidebar-logo {
  width: 180px;
  height: 50px;
  object-fit: contain;
}

.header-decoration {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, #3b82f6 50%, transparent 100%);
  opacity: 0.3;
}

/* Sidebar Content */
.sidebar-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.medical-navigation {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0;
}

.nav-inner {
  padding: 0 1rem;
}

.nav-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

/* Navigation Items */
.nav-item {
  position: relative;
  transition: all 0.2s ease;
}

.nav-section {
  margin: 1.5rem 0 0.75rem;
}

.nav-section:first-child {
  margin-top: 0.5rem;
}

.nav-section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.section-title {
  font-size: 0.75rem;
  font-weight: 600;
  font-weight: bold;
  color: #444E5D;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.section-divider {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, #e2e8f0, transparent);
}

/* Navigation Links */
.nav-link {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0.25rem;
  overflow: hidden;
}

.nav-link:hover {
  background-color: #f8fafc;
  transform: translateX(2px);
}

.nav-link-active {
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.nav-link-active:hover {
  transform: translateX(0);
}

.nav-link-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  position: relative;
  z-index: 2;
}

.nav-icon-container {
  position: relative;
}

.nav-icon-bg {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.nav-icon {
  font-size: 18px;
  color: inherit;
  transition: all 0.2s ease;
}

.nav-link-active .nav-icon {
  color: white;
}

.nav-text {
  font-size: 0.875rem;
  font-weight: bold;
  color: #444E5D;
  transition: all 0.2s ease;
  text-align: start;
}

.nav-link-active .nav-text {
  color: white;
  font-weight: 600;
}

.nav-expand-icon {
  color: #94a3b8;
  transition: all 0.2s ease;
  margin-left: auto;
}

.nav-link-active .nav-expand-icon {
  color: rgba(255, 255, 255, 0.8);
}

.nav-active-indicator {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  border-radius: 2px 0 0 2px;
}

/* Submenu */
.nav-submenu {
  margin-top: 0.5rem;
  margin-left: 1rem;
  padding-left: 1rem;
  border-left: 2px solid #f1f5f9;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.submenu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.submenu-item {
  position: relative;
}

.submenu-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
  font-weight: bold;
}

.submenu-link:hover {
  background-color: #f8fafc;
  transform: translateX(2px);
}

.submenu-link-active {
  font-weight: 600;
}

.submenu-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.submenu-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.submenu-text {
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.footer-decoration {
  margin-bottom: 1rem;
}

.medical-pattern {
  opacity: 0.6;
}

.footer-info {
  display: flex;
  justify-content: center;
}

.platform-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.badge-icon {
  color: #3b82f6;
}

/* Mobile Overlay */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(4px);
}

/* Slide Transition */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .medical-sidebar-container {
    width: 260px;
  }

  .nav-inner {
    padding: 0 0.75rem;
  }

  .nav-link {
    padding: 0.625rem 0.875rem;
  }
}

@media (max-width: 1200px) {
  .medical-sidebar-container {
    width: 280px;
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15);
  }

  .sidebar-header {
    padding: 0 1rem;
  }

  .sidebar-logo {
    max-height: 40px;
    max-width: 160px;
  }
}

@media (max-width: 480px) {
  .medical-sidebar-container {
    width: 260px;
  }

  .nav-link {
    padding: 0.5rem 0.75rem;
  }

  .nav-text {
    font-size: 0.8125rem;
  }

  .submenu-text {
    font-size: 0.8125rem;
  }
}

/* Scrollbar Styling */
.medical-navigation::-webkit-scrollbar {
  width: 4px;
}

.medical-navigation::-webkit-scrollbar-track {
  background: transparent;
}

.medical-navigation::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.medical-navigation::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Focus States */
.nav-link:focus,
.submenu-link:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .medical-sidebar-container {
    border-right-width: 2px;
  }

  .nav-link,
  .submenu-link {
    border: 1px solid transparent;
  }

  .nav-link:hover,
  .submenu-link:hover {
    border-color: #64748b;
  }

  .nav-link-active {
    border-color: white;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  .nav-link,
  .submenu-link,
  .nav-icon,
  .nav-text,
  .nav-expand-icon,
  .submenu-dot {
    transition: none;
  }

  .nav-submenu {
    animation: none;
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: none;
  }
}

/* Utility function for hex to rgb conversion */
.nav-link {
  --primary-rgb: 59, 130, 246;
  /* Default fallback */
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .medical-sidebar-container {
    background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
    border-right-color: #334155;
  }

  .sidebar-header {
    background: #1e293b;
    border-bottom-color: #334155;
  }

  .nav-text {
    color: #e2e8f0;
  }

  .section-title {
    color: #444E5D;
    font-weight: bold;
  }

  .nav-link:hover {
    background-color: #334155;
  }

  .submenu-link {
    color: #94a3b8;
  }

  .submenu-link:hover {
    background-color: #334155;
  }

  .sidebar-footer {
    background: #0f172a;
    border-top-color: #334155;
  }

  .platform-badge {
    background: #1e293b;
    border-color: #334155;
    color: #94a3b8;
  }
}
</style>